export const iconFontAwesomeDisasterCrisisSunPlantWilt = (
	<i className="fa-solid fa-sun-plant-wilt"></i>
);
